// Versão do GyMag mostrada ao utilizador (login, registo, definições).
// Sobe a cada update/deploy para o servidor — é o único sítio a mudar, e tem de bater
// com o "version" do package.json (o teste AppVersionTests verifica).
export const APP_VERSION = '2.40';
export const APP_FOOTER = `GyMag v${APP_VERSION} © 2026`;
